<kc-dialog>
  <ng-template #titleTemplate>Prepare token balance</ng-template>
  <ng-template #contentTemplate>
    <div class="consolidation">
      @if (reserveChunking) {
        <p>
          The wrapper reserve is split across multiple on-chain outputs. Your
          {{ data.requestedTokenAmount }} {{ data.tokenLabel }} unwrap will run
          as sequential transactions.
        </p>
      } @else {
        <p>
          Your {{ data.tokenLabel }} {{ assetLabel }} is split across multiple
          on-chain outputs. Merge them before continuing with
          {{ data.requestedTokenAmount }} {{ data.tokenLabel }}.
        </p>
      }

      <dl class="consolidation__details">
        <div>
          <dt>Total balance</dt>
          <dd>{{ totalBalance }} {{ data.tokenLabel }}</dd>
        </div>
        <div>
          <dt>
            {{
              reserveChunking
                ? 'Largest reserve output'
                : 'Largest usable output'
            }}
          </dt>
          <dd>{{ largestUtxo }} {{ data.tokenLabel }}</dd>
        </div>
        <div>
          <dt>{{ reserveChunking ? 'Reserve outputs' : 'Outputs' }}</dt>
          <dd>{{ outputCount }}</dd>
        </div>
        <div>
          <dt>Approvals</dt>
          <dd>{{ approvals }}</dd>
        </div>
      </dl>

      <p class="consolidation__note">
        Each transaction is signed and indexed before the next one. The
        {{
          data.consolidateAll
            ? 'compatible balance is consolidated when the final transaction completes.'
            : 'requested action continues automatically when its sources are ready.'
        }}
      </p>

      <div class="consolidation__actions">
        <kc-button
          variant="secondary"
          size="m"
          text="Cancel"
          [isFullWidth]="true"
          (buttonClick)="close()"
        />
        <kc-button
          variant="primary"
          size="m"
          [text]="
            data.consolidateAll ? 'Consolidate all' : 'Prepare and continue'
          "
          [isFullWidth]="true"
          (buttonClick)="confirm()"
        />
      </div>
    </div>
  </ng-template>
</kc-dialog>
